import ColorBox from './ColorBox';
import ListBox from './ListBox';
import QABox from './QABox';

export default { QABox, ListBox, ColorBox };
